export enum WorkbenchEvents {
  DocumentationOpened = 'workbench.help.DocumentationOpened',
  KeyboardShortcutsOpened = 'workbench.help.KeyboardShortcutsOpened',
  SidebarCloseWidget = 'workbench.sidebar.CloseWidget',
  SidebarOpenWidget = 'workbench.sidebar.OpenWidget',
  Connect = 'workbench.Connect'
}
